<template>
	<SimpleModal
		@close="onClose"
		accessibleName="datepickermodal"
		:tabOrder="tabOrder"
	>
		<div class="date-picker-content" ref="content">
			<DatePicker
				v-if="isRange"
				v-model.range="value"
				:showTime="showTime"
				:noPastDates="noPastDates"
				:noFutureDates="noFutureDates"
				:min="min"
				:mode="mode"
				:props="props"
				borderless
			/>
			<DatePicker
				v-else
				v-model="value"
				:showTime="showTime"
				:noPastDates="noPastDates"
				:noFutureDates="noFutureDates"
				:min="min"
				:mode="mode"
				:props="props"
				borderless
			/>
			<div class="date-container-buttons">
				<Button @click="onCancel">
					{{ cancelText || $t('common_button_cancel') }}
				</Button>
				<Button primary @click="onSetDate">
					{{ confirmText || $t('announcements_set_time') }}
				</Button>
			</div>
		</div>
	</SimpleModal>
</template>

<script>
import SimpleModal from './SimpleModal'
import DatePicker from './DatePicker'
import Button from './Button'

export default {
	name: 'DatePickerModal',
	components: { SimpleModal, DatePicker, Button },
	data() {
		return { value: this.modelValue }
	},
	emits: ['update:modelValue', 'cancel', 'close', 'confirm'],
	props: {
		modelValue: [String, Date, Number],
		showTime: { type: Boolean, default: null },
		noPastDates: { type: Boolean, default: null },
		noFutureDates: { type: Boolean, default: null },
		mode: String,
		min: [String, Date, Number],
		max: [String, Date, Number],
		confirmText: String,
		cancelText: String,
		props: {
			type: Object,
			default: () => ({}),
		},
		isRange: { type: Boolean, default: null },
	},

	watch: {
		modelValue(modelValue) {
			this.value = modelValue
		},
	},

	computed: {
		tabOrder() {
			return [
				{
					css: '.vc-container .vc-highlight-content-solid',
					clickOnEnter: true,
				},
				{
					css: '.vc-base-select select.vc-align-right', // hour select
					clickOnEnter: true,
				},
				{ css: '.vc-base-select select.vc-align-left', clickOnEnter: true }, // minute select
				{
					css:
						'.vc-base-select select:not(.vc-align-right):not(.vc-align-left)', // AM/PM select
					clickOnEnter: true,
				},
				{ css: '.pronto-btn.default', clickOnEnter: true },
				{ css: '.pronto-btn.primary', clickOnEnter: true },
			]
		},
	},

	methods: {
		onSetDate() {
			let val = this.value
			const m = this.$m(val)
			if (this.noPastDates && m.isBefore(this.$m())) {
				val = null
			} else if (this.max && m.isAfter(this.$m(this.max))) {
				val = null
			} else if (this.min && m.isBefore(this.$m(this.min))) {
				val = null
			}
			this.$emit('update:modelValue', val)
			this.$emit('confirm', val)
			this.onClose()
		},
		onCancel() {
			this.$emit('cancel')
			this.onClose()
		},
		onClose() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
.date-picker-content {
	padding: 48px 36px 24px 36px;

	.date-container-controls {
		margin-top: 16px;
		display: flex;
		justify-content: space-between;
	}

	.date-container-buttons {
		margin-top: 16px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}
</style>
